// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group{
display: flex;
}

.accordion{
    margin-top: 2rem;
    border: none;
    display: block;
    background-color: white;
}

.flexCenter {
    display: flex;
    row-gap: 2rem;
    justify-content: center;
    align-items: center;
  }

.accordionItem{
    background-color: white;
    border: .8px solid rgb(128 128 128 / 14.3%);
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.accordionItem.expanded{
    box-shadow: var(--shadow);
    border-radius: 6px;
}

.primary-text {
    color: white;
    font-weight: bold;
    font-size: 14px;
  }

.accordionButton{
    font-weight: 600;
    font-size: 16px;
    color: #fff;
    background-color: #2067d1;
    padding: 5px 14px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.icon{
    padding: 10px;
    background: transparent;
    border-radius: 5px;
}

.icon svg {
  fill: var(--white);
}

.accordionButton .primary-text{
    font-size: 14px;
}

@media (width <=1024px) {
   .v-container{
    flex-direction: column;
   }

   @media (width <=768px) {
    .accordionButton .primary-text{
        font-size: 0.8rem;
    }
   }

   @media (width <= 640px) {
    .primary-text {
      font-size: 1.5rem;
    }

    .orange-text {
      font-size: 1.2rem;
    }
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/accordion.css"],"names":[],"mappings":"AAAA;AACA,aAAa;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;AAEF;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;GACG;IACC,sBAAsB;GACvB;;GAEA;IACC;QACI,iBAAiB;IACrB;GACD;;GAEA;IACC;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;EACF;AACF","sourcesContent":[".group{\ndisplay: flex;\n}\n\n.accordion{\n    margin-top: 2rem;\n    border: none;\n    display: block;\n    background-color: white;\n}\n\n.flexCenter {\n    display: flex;\n    row-gap: 2rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n.accordionItem{\n    background-color: white;\n    border: .8px solid rgb(128 128 128 / 14.3%);\n    border-radius: 8px;\n    overflow: hidden;\n    margin-bottom: 20px;\n}\n\n.accordionItem.expanded{\n    box-shadow: var(--shadow);\n    border-radius: 6px;\n}\n\n.primary-text {\n    color: white;\n    font-weight: bold;\n    font-size: 14px;\n  }\n\n.accordionButton{\n    font-weight: 600;\n    font-size: 16px;\n    color: #fff;\n    background-color: #2067d1;\n    padding: 5px 14px;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.icon{\n    padding: 10px;\n    background: transparent;\n    border-radius: 5px;\n}\n\n.icon svg {\n  fill: var(--white);\n}\n\n.accordionButton .primary-text{\n    font-size: 14px;\n}\n\n@media (width <=1024px) {\n   .v-container{\n    flex-direction: column;\n   }\n\n   @media (width <=768px) {\n    .accordionButton .primary-text{\n        font-size: 0.8rem;\n    }\n   }\n\n   @media (width <= 640px) {\n    .primary-text {\n      font-size: 1.5rem;\n    }\n\n    .orange-text {\n      font-size: 1.2rem;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
